import isEqual from 'lodash/isEqual';
import { IPlatform } from '@evercall/domain/vo/Platform';
import { DEFAULT_WEBINAR_PLATFORM_NAME } from '../constants';
import { mapToDefaultOption } from '@framework/data-helpers/selectOptionMappers';
import { IDefaultSelectOption } from '@dealroadshow/uikit-select';

export const getPlatformOption = (
  platformList: IPlatform[],
  id?: string,
) => mapToDefaultOption(
  platformList.find(
    (platform) => (
      id
        ? isEqual(platform.id, id)
        : isEqual(platform.name, DEFAULT_WEBINAR_PLATFORM_NAME)
    ),
  ),
) as IDefaultSelectOption;
